import { useTranslation } from 'react-i18next';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ScrollArea } from '@/components/ui/scroll-area';
import { ShieldCheck } from 'lucide-react';

export const PrivacyPolicyModal = ({ isOpen, onClose }) => {
    const { t } = useTranslation();

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[600px] max-h-[85vh] p-0">
                <DialogHeader className="p-6 pb-0">
                    <DialogTitle className="flex items-center gap-3 text-2xl font-display">
                        <div className="w-10 h-10 rounded-xl bg-primary flex items-center justify-center">
                            <ShieldCheck className="w-5 h-5 text-primary-foreground" />
                        </div>
                        {t('privacy.title')}
                    </DialogTitle>
                </DialogHeader>
                
                <ScrollArea className="max-h-[60vh] px-6 pb-6">
                    <div className="space-y-6 pt-4">
                        {/* Introduction */}
                        <div className="p-4 rounded-xl bg-primary/5 border border-primary/10">
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {t('privacy.intro')}
                            </p>
                        </div>

                        {/* Section 1 */}
                        <div>
                            <h3 className="font-semibold text-foreground mb-2">{t('privacy.section1Title')}</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {t('privacy.section1Text')}
                            </p>
                        </div>

                        {/* Section 2 */}
                        <div>
                            <h3 className="font-semibold text-foreground mb-2">{t('privacy.section2Title')}</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {t('privacy.section2Text')}
                            </p>
                        </div>

                        {/* Section 3 */}
                        <div>
                            <h3 className="font-semibold text-foreground mb-2">{t('privacy.section3Title')}</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {t('privacy.section3Text')}
                            </p>
                        </div>

                        {/* Section 4 */}
                        <div>
                            <h3 className="font-semibold text-foreground mb-2">{t('privacy.section4Title')}</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {t('privacy.section4Text')}
                            </p>
                        </div>

                        {/* Section 5 */}
                        <div>
                            <h3 className="font-semibold text-foreground mb-2">{t('privacy.section5Title')}</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {t('privacy.section5Text')}
                            </p>
                        </div>

                        {/* Section 6 - Contact */}
                        <div className="p-4 rounded-xl bg-accent/10 border border-accent/20">
                            <h3 className="font-semibold text-foreground mb-2">{t('privacy.section6Title')}</h3>
                            <p className="text-sm text-muted-foreground leading-relaxed">
                                {t('privacy.section6Text')}
                            </p>
                        </div>
                    </div>
                </ScrollArea>

                <div className="p-6 pt-0">
                    <Button 
                        onClick={onClose} 
                        className="w-full btn-premium rounded-full"
                    >
                        {t('privacy.close')}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};
